import { YourTrips } from "@opensea/ui-kit/icons"
import React from "react"
import { useRouter } from "next/router"
import { SettingsItem } from "./SettingsItem.react"

export function DebugItem() {
  const router = useRouter()

  return (
    <div className="bg-yellow-1">
      <SettingsItem
        icon={<YourTrips />}
        label="Debug"
        onClick={() => router.push("/debug")}
      />
    </div>
  )
}
